module.exports = __webpack_public_path__ + "static/media/under-construction.62a77100.jpg";